import postCheckout from "./modules/post.checkout";

export default {
  postCheckout
};
